module.exports = __webpack_public_path__ + "static/96260f7074e12a2e67069bccdbbecd24474abdb90133c29d50c7256c873703ee-13db609184e5fca9236fd3acb64339fb.png";